/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { futuresList } from "../../funcs/futuresList.js";
import { formatResult, ToolDefinition } from "../tools.js";

export const tool$futuresList: ToolDefinition = {
  name: "futures-list",
  description: `List all available futures

Returns a list of all available future symbols that
        Hedgewise tracks.`,
  tool: async (client, ctx) => {
    const [result, apiCall] = await futuresList(
      client,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
